<template>
  <ScModal
    :show="show"
    class="confirmation-modal"
    @close="close"
  >
    <div class="modal-body">
      <span class="text">
        {{ text }}
      </span>
      <ScButton
        variant="primary"
        class="form-button close-btn"
        @click="onSubmit"
      >
        {{ $t(`account.applyConfirmation`) }}
      </ScButton>
      <ScButton
        variant="gray"
        class="form-button submit-btn"
        @click="close"
      >
        {{ $t(`account.close`) }}
      </ScButton>
    </div>
  </ScModal>
</template>

<script>
import ScButton from '@trendyol/sc-ui-kit/ScButton';
import ScModal from '@trendyol/sc-ui-kit/ScModal';

export default {
  name: 'ConfirmationModal',
  components: { ScButton, ScModal },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Çalışma Modu değişikliğinizi onaylıyor musunuz?',
    },
  },
  methods: {
    close () {
      this.$emit('close');
    },
    onSubmit () {
      this.$emit('submit');
    },
  },
};
</script>

<style lang="scss" scoped>
  .confirmation-modal{
    position: fixed !important;
    & .modal-body{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 30px;

      .text{
        font-size: 20px;
        font-weight: 500;
        color: #273142;
        text-align: center;
        margin: 30px 0 10px 0;
      }

      .form-button{
        margin-top: 20px;
      }
    }
  }
</style>
